module.exports = __webpack_public_path__ + "static/childhood-cancer-desktop.33881205.webp";